/** 消息管理路由 */
export default {
    name: 'messageManage',
    path: 'messageManage',
    meta: {
        title: '消息管理'
    },
    component: ()=>import('@/pages/messageManage/messageManage.vue'),
    children: []
}